import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './config/msal-config.js';
import { setMsalInstance } from './api/client.js';
import { App } from './App.js';
import { initRum } from './utils/rum.js';
import './index.css';

performance.mark('payplan:msal-init-start');

const rootElement = document.getElementById('root');
if (rootElement === null) {
  throw new Error('Root element not found');
}

const msalInstance = new PublicClientApplication(msalConfig);
setMsalInstance(msalInstance);

void msalInstance.initialize().then(() => {
  performance.mark('payplan:msal-init-end');
  performance.measure('payplan:msal-init', 'payplan:msal-init-start', 'payplan:msal-init-end');
  initRum();
  createRoot(rootElement).render(
    <StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </StrictMode>,
  );
});
